<div class="one" [formGroup]="SettingForm" fxLayout="column">
  <div fxLayout="row wrap" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <mat-form-field
      appearance="outline"
      class="silq-imput pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.PINPAYMENTSAPIKEY),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.PINPAYMENTSAPIKEY),
      }"
    >
      <mat-label>Payment API Key</mat-label>
      <input class="sideText" matInput formControlName="PINPAYMENTSAPIKEY" />
    </mat-form-field>
    <mat-form-field
      appearance="outline"
      class="silq-imput-1 pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.PINPAYMENTSABSORBFEE),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.PINPAYMENTSABSORBFEE),
      }"
    >
      <mat-label>Who Pays The Fee?</mat-label>
      <mat-select name="PINPAYMENTSABSORBFEE" formControlName="PINPAYMENTSABSORBFEE">
        @for (optionval of silqPayDrop; track optionval) {
          <mat-option value="{{ optionval.DESCRIPTION }}">
            {{ optionval.DESCRIPTION }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
    <mat-hint class="api-key-note" [class.dark-theme]="theme_type?.includes('dark')">
      <strong>
        *The Payment API key must be the Live Secret Key provided by PinPayments once you complete
        your account setup.
      </strong>
    </mat-hint>
  </div>
  <div fxLayout="row wrap" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <div fxFlex="100" class="text-[14px]">
      1. Client pays SILQ Pay Fee- The Fee is added on top of the invoice amount.
      <br />
      Eg Invoice Total = $100, Fee =$2.30*, Client is charged $102.30, you receive $100.
      <br />
      <br />
    </div>
    <div fxFlex="100" class="text-[14px]">
      2.We absorb the SILQ Pay Fee - The fee is included in the invoice total.
      <br />
      Eg Invoice Total = $100, Fee =$2.30*, Client is charged $100, you receive $97.70.
      <br />
      <br />
    </div>
    <div fxFlex="100" class="text-[14px]">
      *Check rates at
      <a href="http://silqpay.com" target="_blanck" class="text-[14px]">silqpay.com</a>
      <br />
      <br />
    </div>
  </div>
  <div fxLayout="row wrap" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <mat-form-field
      appearance="outline"
      class="silq-imput-3 pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.SILQPAYLINKDESC),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.SILQPAYLINKDESC),
      }"
    >
      <mat-label>Email Link Desc</mat-label>
      <input class="sideText" matInput formControlName="SILQPAYLINKDESC" />
    </mat-form-field>
  </div>
  <div fxLayout="row wrap" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <div class="silq-imput-2">
      <mat-checkbox formControlName="SILQPAYSHOWINVDETAILS">Show Invoice Details</mat-checkbox>
    </div>
    <div class="silq-imput-2">
      <mat-checkbox formControlName="SILQPAYSHOWCHEQUEPAYMENT">Show Cheque Payment</mat-checkbox>
    </div>
    <div class="silq-imput-2">
      <mat-checkbox formControlName="SILQPAYSHOWDDPAYMENT">Show Direct Debit Payment</mat-checkbox>
    </div>
    <div class="silq-imput-2">
      <mat-checkbox formControlName="SILQPAYSHOWINVOICESTATEMENT1">
        Show Inv Statement 1
      </mat-checkbox>
    </div>
    <div class="silq-imput-2">
      <mat-checkbox formControlName="SILQPAYSHOWINVOICESTATEMENT2">
        Show Inv Statement 2
      </mat-checkbox>
    </div>
    <div class="silq-imput-2">
      <mat-checkbox formControlName="SILQPAYSHOWINVOICESTATEMENT3">
        Show Inv Statement 3
      </mat-checkbox>
    </div>
    <div class="silq-imput-2">
      <mat-checkbox formControlName="SILQPAYSHOWFEEAGRSTATEMENT">
        Show Inv Fee Agr Statement
      </mat-checkbox>
    </div>
    <div class="silq-imput-2">
      <mat-checkbox formControlName="SILQPAYSHOWGLOBALFOOTER">Show Global Footer</mat-checkbox>
    </div>
  </div>
  <div align="end">
    <mat-dialog-actions class="popup_ftr">
      <button
        id="callApiId"
        class="mainbtn_size"
        matButton="filled"
        [disabled]="isspinerInfo"
        (click)="saveSilqPay()"
      >
        @if (isspinerInfo) {
          <mat-spinner diameter="24"></mat-spinner>
        }
        Save
      </button>
      <!-- <button class="btn_2" mat-raised-button color="primary" cdkFocusInitial>Don't Save</button> -->
    </mat-dialog-actions>
  </div>
</div>
